import colors from '@/styles/colors';
import styled from 'styled-components';
import { FiArrowLeft } from 'react-icons/fi';

export const SignInOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
`;

export const IconBack = styled(FiArrowLeft)`
  font-size: 20px;
  color: ${colors.hardGray};
`;

export const Form = styled.form`
  > label {
    > span {
      font-weight: 600;
      font-weight: normal;
      color: ${colors.error};
    }
  }
`;

export const Footer = styled.div`
  color: ${colors.hardGray};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-top: 24px;

  a {
    margin-left: 3px;
  }
`;
